/*
 * Project: LegalPlace assistant
 * File: src\logic\lp_map_utils.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */
export const ARCHITECTURE = 'contract_architecture';
export const CONTRACT_NAME = 'contract_name';
export const SECTIONS = 'sections';
// ---------------IN SINGLE SECTION------------------------
export const LABEL = 'label';
export const OPTS = 'options';
export const MULTIPLE = 'multiple';

// -------------------------------------------------------
export const VARIABLES = 'variables_wrapper';
export const OPTIONS = 'options_wrapper';

// ------------------ OPTIONS IN OPTIONWRAPPERS -----------
export const META = 'meta';
export const TYPE = 'type';
// LABEL extits
export const RENDERER = 'outputRender';
export const HELPER = 'helper';
export const ISCONDITIONAL = 'conditional';
// ---- FOR THE Varibale wrapper
export const FSIZE = 'phsize';
export const MULTIPLE_PARENTS = 'parentMultiple';

export const VARS = 'variables';
export const CHILDS = 'children';

// ------------------ INPUTS TYPES ------------------------
export const OptionType = {
  NONE: 69,
  HIDDEN: 0,
  TEXT: 1,
  RADIO: 2,
  CHECKBOX: 3,
  STATIC: 4,
  DATE: 5,
  LIST: 6,
  TEXTAREA: 7,
  PURE: 8,
  REPEATED: 9,
  EVAL: 10,
  NUMBER: 11,
  BASICMASK: 12,
  ADVANCEDMASK: 13,
  HOUR: 14,
  EMAIL: 15
};
export const SOptionType = OptionType;
export function detectType(t_text) {
  switch (t_text) {
    case 'text':
      return SOptionType.TEXT;
    case 'radio':
      return SOptionType.RADIO;
    case 'hidden':
      return SOptionType.HIDDEN;
    case 'checkbox':
      return SOptionType.CHECKBOX;
    case 'static':
      return SOptionType.STATIC;
    case 'date':
      return SOptionType.DATE;
    case 'list':
      return SOptionType.LIST;
    case 'textarea':
      return SOptionType.TEXTAREA;
    case 'brut-text':
      return SOptionType.PURE;
    case 'repeated':
      return SOptionType.REPEATED;
    case 'eval':
      return SOptionType.EVAL;
    case 'number':
      return SOptionType.NUMBER;
    case 'mask':
      return SOptionType.BASICMASK;
    case 'mask':
      return SOptionType.BASICMASK;
    case 'advancedmask':
      return SOptionType.ADVANCEDMASK;
    case 'hour':
      return SOptionType.HOUR;
    case 'email':
      return SOptionType.EMAIL;
    default:
      return SOptionType.NONE;
  }
}



// WEBPACK FOOTER //
// ./src/logic/lp_map_utils.js